module.exports = __webpack_public_path__ + "img/Canal_News_logo.45aea593.svg";